import React from "react";
import classNames from "classnames";
import { Button, makeStyles, Text, typographyStyles } from "@fluentui/react-components";
import {
  ChevronDown12Regular,
  ChevronRight12Regular,
  Dismiss12Regular,
} from "@fluentui/react-icons";
import { OutlineStyleCount } from "./OutlineStyleCount";
import "./OutlineCategory.css";

import type { MouseEventHandler } from "react";
import type { TOutlineGroup } from "./types";

const useStyles = makeStyles({
  text: typographyStyles.body1Strong,
});

export interface OutlineCategoryProps
  extends TOutlineGroup, Omit<React.HTMLAttributes<HTMLDivElement>, "id" | "part"> {
  expanded?: boolean;
  notInProfile?: boolean;
  selected: boolean;
  onExpand?: MouseEventHandler<HTMLButtonElement>;
  onClearGroup: () => void;
  onSelectGroup: (group: string | null) => void;
  onSetBoundaryIndices: (boundaryIndices: [number, number], style?: string | null) => void;
}

export function OutlineCategory({
  boundaryIndices,
  changes,
  className,
  expanded,
  id: _id,
  name,
  notInProfile,
  part,
  selected,
  styleGroup,
  total,
  onExpand,
  onClearGroup,
  onSelectGroup,
  onSetBoundaryIndices,
  ...props
}: OutlineCategoryProps) {
  const styles = useStyles();

  const handleClick = () => {
    if (boundaryIndices) {
      onSetBoundaryIndices(boundaryIndices, null);
    }
    onSelectGroup(name);
  };

  return (
    <div
      className={classNames("outline-category", {
        "outline-category-not-in-profile": notInProfile,
        selected,
      })}
      onClick={handleClick}
      {...props}
    >
      <Button
        appearance="transparent"
        icon={expanded ? <ChevronDown12Regular /> : <ChevronRight12Regular />}
        onClick={onExpand}
        style={{ border: 0, padding: "0px", maxWidth: "16px", minWidth: "16px" }}
      />
      <Text className={styles.text}>{name}</Text>
      <OutlineStyleCount
        style="strong"
        total={total}
        changes={changes}
        notInProfile={notInProfile}
      />
      {selected && (
        <Button
          appearance="transparent"
          icon={<Dismiss12Regular />}
          onClick={(e) => {
            e.stopPropagation();
            onClearGroup();
          }}
          style={{ border: 0, padding: "0px", maxWidth: "20px", minWidth: "20px" }}
        />
      )}
    </div>
  );
}
